import React from "react";

import "./styles/Widget1vs1CurrentMatch.css";

import MapDataHelper from "../data/MapDataHelper";

export default function Widget1vs1CurrentMatch({
  currentMatchMap,
  hostCurrentMatchCiv,
  guestCurrentMatchCiv,
}) {
  const mapImage = MapDataHelper.getMapImage(currentMatchMap);
  return (
    <>
      <div className="current-match">
        <div className="civs">
          <div className="civ-host">
            <img
              src={`./civs/${hostCurrentMatchCiv}.png`}
              alt={hostCurrentMatchCiv}
              title={hostCurrentMatchCiv}
            />
          </div>
          <div className="civ-guest">
            <img
              src={`./civs/${guestCurrentMatchCiv}.png`}
              alt={guestCurrentMatchCiv}
              title={guestCurrentMatchCiv}
            />
          </div>
        </div>
        {currentMatchMap ? (
          <img
            src={`${mapImage}`}
            alt={currentMatchMap}
            title={currentMatchMap}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}
